<template>
    <div style="display:none"></div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

<script>
export default {
    created(){
        this.$router.push("/account");
    }
}
</script>
